export const rowKey = () => Math.random().toString(36).slice(2, 10);
